<!-- Áridos: UI legacy -->
<div>
  <div class="notification" [ngClass]="{ hideNotificationCss: !isNotificationVisible }">
    <i class="bi bi-check-circle-fill notification-icon"></i>
    <span class="notification-text">Guía de despacho enviada al
      cliente exitósamente.</span>
    <i class="bi bi-x-lg close-icon" (click)="hideNotification()"></i>
  </div>

  <div *ngIf="showClientQr" style="text-align: center">
    <div class="qr-wrapper">

      <qrcode [qrdata]="linkQr" class="qr-code" [class.qr-blur]="qrState !== 'ready'">
        <div class="qrcode">
          <canvas></canvas>
        </div>
      </qrcode>

      <div *ngIf="qrState === 'syncing'" class="qr-overlay">
        <div class="spinner-border text-primary" role="status"></div>
        <p>Enviando datos...</p>
      </div>

      <div *ngIf="qrState === 'offline'" class="qr-overlay qr-overlay--offline">
        <i class="bi bi-wifi-off qr-offline-icon"></i>
        <p>Sin conexión</p>
      </div>

    </div>
  </div>

  <div class="text-title">
    <label>Firmar guía</label>
  </div>

  <div class="texto-simple" (click)="withoutInternet()">
    <span>¿Sin conexión? <a style="cursor: pointer">Continúa aquí</a></span>
  </div>
  <div class="d-md-flex justify-content-md-center qr-buttons mt-md-4">

    <div class="space-button">
      <button type="button" class="btn btn-primary-nofirma" (click)="onOpenModal()">
        Continuar guía No Firmada
      </button>
    </div>

    <div class="space-button ml-md-4" *ngIf="qrState !== 'offline'">
      <button type="button" class="btn btn-primary-volver" (click)="goBack()">
        Ir a Historial
      </button>
    </div>

  </div>

  <div class="texto-simple" (click)="firmaPapel()">
    <span style="cursor: pointer"><a>Continuar Guía Firmada en Papel</a></span>
  </div>
</div>

<!-- Modal guía no firmada (compartido) -->
<div class="margin-lateral-modal">
  <ng-template #contenidoModal>
    <div class="dashboard container guia-no-firmada-modal" style="padding: 1rem; padding-bottom: 0px">
      <button
        type="button"
        mat-icon-button
        class="close-icon close-button"
        aria-label="Cerrar modal"
        (click)="onCierrenModal()">
        <i class="bi bi-x-lg"></i>
      </button>

      <div style="text-align: center">
        <i
          *ngIf="PasoModal.preguntaModal"
          class="bi bi-exclamation-triangle-fill"
          style="color:#f1ae2f; transform: scale(1.4); display:inline-block;"></i>
        <i
          *ngIf="!PasoModal.preguntaModal"
          class="bi bi-check-circle"
          style="color:#007a47; transform: scale(1.4); display:inline-block;"></i>
        <br />
        <h6 class="text-title-modal">{{ tituloModal }}</h6>
        <p class="text-descripcion-modal">{{ descripcionModal }}</p>
      </div>
      <div style="display: flex" *ngIf="PasoModal.preguntaModal">
        <div class="buttons" style="width: 47.5%; margin-right: auto">
          <a href="javascript:void(0)" class="btn back-button" (click)="onCierrenModal()">Seguir editando</a>
        </div>
        <div class="buttons" style="width: 47.5%">
          <a
            href="javascript:void(0)"
            class="btn btn-primary btn-back btn-l-md"
            (click)="confirmarGuiaNoFirmada()">Confirmar</a>
        </div>
      </div>
      <div *ngIf="!PasoModal.preguntaModal">
        <button type="button" class="btn btn-primary mb-2" (click)="onCierrenModal()">
          Aceptar
        </button>
      </div>
    </div>
  </ng-template>
</div>

<!-- Modal éxito firma desde galería (hormigón) -->
<div class="margin-lateral-modal">
  <ng-template #contenidoModalPapel>
    <div class="dashboard container" style="padding: 1rem; padding-bottom: 0px">
      <div style="text-align: center">
        <i class="bi bi-check-circle" style="color:#007a47; transform: scale(1.4); display:inline-block;"></i>
        <br />
        <h6 class="text-title-modal">
          {{ papelSavedOffline ? 'Fotografía guardada' : 'Guía firmada exitosamente' }}
        </h6>
        <p class="text-descripcion-modal">
          {{
            papelSavedOffline
              ? 'Tu fotografía se enviará al servidor cuando recuperes conexión.'
              : 'La fotografía fue enviada correctamente.'
          }}
        </p>
      </div>
      <div>
        <button type="button" class="btn btn-primary" (click)="onCierrenModalPapel()">
          Aceptar
        </button>
      </div>
    </div>
  </ng-template>
</div>

<!-- Modal verificación firma QR (hormigón) -->
<div class="margin-lateral-modal">
  <ng-template #contenidoModalQrContinuar>
    <div class="dashboard container qr-continuar-modal" style="padding: 1rem; padding-bottom: 0px">
      <button
        *ngIf="qrContinuarModalState === 'pending' || qrContinuarModalState === 'error'"
        mat-icon-button
        class="close-icon close-button"
        (click)="onCancelarModalQrContinuar()">
        <i class="bi bi-x-lg"></i>
      </button>

      <div *ngIf="qrContinuarModalState === 'loading'" class="qr-continuar-modal__body">
        <div class="spinner-border text-primary qr-continuar-modal__spinner" role="status"></div>
        <p class="text-descripcion-modal">Consultando firma...</p>
      </div>

      <div *ngIf="qrContinuarModalState === 'pending'" class="qr-continuar-modal__body">
        <i class="bi bi-exclamation-triangle-fill qr-continuar-modal__icon qr-continuar-modal__icon--warning"></i>
        <h6 class="text-title-modal">La guía aún no se firma</h6>
      </div>

      <div *ngIf="qrContinuarModalState === 'success'" class="qr-continuar-modal__body">
        <i class="bi bi-check-circle-fill qr-continuar-modal__icon qr-continuar-modal__icon--success"></i>
        <h6 class="text-title-modal">Guía firmada con éxito</h6>
        <p class="text-descripcion-modal">Firma enviada correctamente al servidor.</p>
      </div>

      <div *ngIf="qrContinuarModalState === 'error'" class="qr-continuar-modal__body">
        <i class="bi bi-exclamation-triangle-fill qr-continuar-modal__icon qr-continuar-modal__icon--warning"></i>
        <h6 class="text-title-modal">Error al consultar</h6>
        <p class="text-descripcion-modal">{{ qrContinuarError }}</p>
      </div>

      <div
        *ngIf="qrContinuarModalState === 'pending' || qrContinuarModalState === 'error'"
        class="qr-continuar-modal__actions">
        <div class="buttons" style="width: 47.5%; margin-right: auto">
          <button
            type="button"
            class="btn btn-danger btn-l-md"
            (click)="onCancelarModalQrContinuar()">
            Cancelar
          </button>
        </div>
        <div class="buttons" style="width: 47.5%">
          <a
            href="javascript:void(0)"
            class="btn btn-primary btn-back btn-l-md"
            (click)="onConsultarNuevamenteQr()">Consultar</a>
        </div>
      </div>

      <div *ngIf="qrContinuarModalState === 'success'">
        <button type="button" class="btn btn-primary" (click)="onAceptarFirmaQrExito()">
          Aceptar
        </button>
      </div>
    </div>
  </ng-template>
</div>

